import CardHeader from "../../../../atoms/CardHeader";
import { getTabla } from "../../../../../utils/getTablas";
import Breadcrumb from "../../../../molecules/Breadcrumb";
import useModal from "../../../../../hooks/useModal";
import Button from "../../../../atoms/Button";
import { AiOutlineInfo } from "react-icons/ai";
import Modal from "../../../../molecules/Modal";
import InfoEmpresa from "../../../../templates/clientes/InfoEmpresa";

const MenuDocHeader = ({ empresa, tabla }) => {
    const { open: openInfo, close, isOpen } = useModal();

    return(
        <CardHeader>
            <Breadcrumb
                items={[
                    { label: `${empresa?.name || "cargando..."}`, to: `/clientes/empresas/${empresa?.id}/decide` },
                    { label: "CONTABILIDAD", to: `/clientes/empresas/${empresa?.id}` },
                    { label: `${getTabla(tabla)}`, to: null },
                ]}
            />
            <Button
                    text={<AiOutlineInfo size={22} />}
                    bgColor="black"
                    width="w-10"
                    onClick={openInfo}
                />
            {isOpen && empresa &&
                <Modal title="Información" onClose={close}>
                    <InfoEmpresa empresa={empresa} />
                </Modal>
            }
        </CardHeader>
    )
}

export default MenuDocHeader;